// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3HOBs","errorLogs":"styles_errorLogs__2anT5"};